/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { isStrEmpty } from '../common/UtilityFunctions';
import css from '../css/loan-escrow-accruals-styles/LoanServicingEscrowAccrualsPage.module.css';
import LoanEscrowAccrualsMain from '../components/loan-escrow-accruals/LoanEscrowAccrualsMain';
import EnvelopeWithBox from '../components/EnvelopeWithBox';
import LoadingModal from '../components/modals/LoadingModal';
import { useLoanContext } from '../contexts/LoanContext';
import { useAuthContext } from '../contexts/AuthContext';
import useLoanInfo from '../common/hooks/useLoanInfo';
import * as constants from '../common/constants';

const LoanServicingEscrowAccrualsPage: React.FC = () => {
  const { loanNumber } = useLoanContext();
  const { token } = useAuthContext();

  const { data: loanInfoData, status: loanInfoStatus, error: loanInfoError } = useLoanInfo(loanNumber, token);

  console.log('Loan Info Status: ' + loanInfoStatus);

  if (isStrEmpty(loanNumber)) {
    return (
      <EnvelopeWithBox blockName='Loan Escrow Accruals'>
        <p className={css.errorMsg}>No loan currently selected! Cannot display loan escrow accrual information.</p>
      </EnvelopeWithBox>
    );
  }

  if (loanInfoStatus === 'pending')
    return (
      <EnvelopeWithBox blockName='Loan Escrow Accruals'>
        <LoadingModal open={true} />
      </EnvelopeWithBox>
    );
  if (loanInfoStatus === 'error') {
    return (
      <EnvelopeWithBox blockName='Loan Escrow Accruals'>
        {loanInfoStatus === 'error' && <div>{loanInfoError.message}</div>}
      </EnvelopeWithBox>
    );
  }
  const isLoanFhaUsda: boolean = loanInfoData.loanFha || loanInfoData.loanUsda;
  return (
    <EnvelopeWithBox blockName='Loan Escrow Accruals'>
      <LoanEscrowAccrualsMain
        upfrontMIP={loanInfoData.upfrontMIPFinanced}
        upfrontPMI={loanInfoData.upFrontPMIFinanced}
        miCompany={loanInfoData.miCompany}
        miCertificate={loanInfoData.miCertificate}
        fhaCaseNo={loanInfoData.agencyCaseNumber}
        closingDate={loanInfoData.closingDate}
        amortTerm={loanInfoData.amortizationTerm}
        ltv={loanInfoData.ltv}
        isLoanFhaUsda={isLoanFhaUsda}
      ></LoanEscrowAccrualsMain>
    </EnvelopeWithBox>
  );
};

export default LoanServicingEscrowAccrualsPage;
